import React from "react";
import "./App.css";
import { VIR } from "./calculators/VIR";
import { VOIW } from "./calculators/VOIW";
import { LCF } from "./calculators/LCF";
import { FCL } from "./calculators/FCL";

function App() {
  return (
    <div className="App">
      <div className="block">
        <VIR volt="1" amp="1" />
        <VOIW volt="1" ohm="50" />
        <LCF l="1" c="1" />
        <FCL f="1" c="1" />
      </div>
    </div>
  );
}

export default App;
